import React from 'react';
import Heart from './Heart';
const HeartXS = ({ color, ...props }) => (React.createElement(Heart, Object.assign({ color: color, size: 16 }, props)));
HeartXS.displayName = 'HeartXS'; // Fix for tsc
export default HeartXS;
//# sourceMappingURL=HeartXS.js.map